export enum ApplicationSettingKey {
    AllowOrdering = "AllowOrdering",
    WhatsAppWbaId = "WhatsAppWbaId",
}